import { useIsAuth } from 'feature/auth/hooks'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { ProductOrder } from 'feature/productOrder/ProductOrder'
import { useGetMainPageDataQuery } from 'feature/user/redux/user.api'
import { MainLayout } from 'layouts'
import { Navigate } from 'react-router'
import { useAppSelector } from 'store/hooks'
import { LoaderInCentalPosition } from 'widget/LoaderInCentalPosition/LoaderInCentalPosition'

export function ProductOrderPage() {
  const isAuth = useIsAuth()
  const clientType = useAppSelector(state => state.auth.authInfo.clientType)

  // Если auth и clientType неизвестен — запрашиваем профиль
  // RTK Query дедублирует запрос если он уже выполняется (например из Menu)
  const { isLoading } = useGetMainPageDataQuery(undefined, {
    skip: !isAuth || !!clientType,
  })

  // Авторизованный ЮЛ попал на /productorder — отправляем на правильную форму
  if (isAuth && clientType === 'company') {
    return <Navigate to='/company/productorder' replace />
  }

  // Ждём ответа профиля чтобы определить тип пользователя
  if (isAuth && !clientType && isLoading) {
    return (
      <MainLayout>
        <LoaderInCentalPosition />
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <ProductOrder orderType={orderFormSpace.FormType.new} />
    </MainLayout>
  )
}
